import * as React from "react"

import { WithDragging, DraggableProps } from "./hoc/WithDragging"
import { DeprecatedFrameWithEvents, DeprecatedFrameWithEventsProps } from "../render"

/** @public */
export const Draggable: React.ComponentClass<
    Partial<DeprecatedFrameWithEventsProps> & Partial<DraggableProps<typeof DeprecatedFrameWithEvents>>
> = WithDragging(DeprecatedFrameWithEvents)
